import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static targets = ['sortable', 'handle'];
  static values = {
    handle: String,
    group: String,
    resource: String,  // e.g., "tax_organizer_question_template"
    url: String        // Base URL for reordering endpoint
  };

  connect() {
    const options = {
      animation: 150,
      handle: this.hasHandleValue ? this.handleValue : this.data.get('handle'),
      ghostClass: 'sortable-ghost',
      dragClass: 'sortable-drag',
      onEnd: (event) => {
        if (event.newIndex === event.oldIndex) return;

        this.updatePosition(event);
      }
    };

    const group = this.hasGroupValue ? this.groupValue : this.data.get('group');
    if (group) {
      options.group = group;
    }

    Sortable.create(this.sortableTarget, options);
  }

  updatePosition(event) {
    const movedItem = event.item;
    const position = event.newIndex + 1;

    // Get URL from either data-sortable-path attribute on item or from controller value
    const url = movedItem.getAttribute('data-sortable-path') || this.urlValue;

    if (!url) {
      console.error('No URL specified for sortable update. Set data-sortable-path on items or data-sortable-url-value on controller.');
      return;
    }

    // Get resource name from controller value (e.g., "tax_organizer_question_template")
    const resourceName = this.hasResourceValue ? this.resourceValue : 'item';

    // Build nested params: { tax_organizer_question_template: { position: 2 } }
    const data = { [resourceName]: { position: position } };

    fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    }).catch(error => {
      console.error('Error updating position:', error);
    });
  }
}
